import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex flex-col overflow-hidden pt-4 w-full bg-white" }
const _hoisted_2 = { class: "h-screen py-4 overflow-y-auto" }
const _hoisted_3 = { class: "flex flex-row" }
const _hoisted_4 = { class: "w-4/12 text-12px xxl:text-14px" }
const _hoisted_5 = { class: "flex flex-row" }
const _hoisted_6 = { class: "w-6/12 text-12px xxl:text-14px" }
const _hoisted_7 = { class: "flex flex-row" }
const _hoisted_8 = /*#__PURE__*/_createVNode("hr", { class: "mt-2" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("hr", { class: "mt-2" }, null, -1)
const _hoisted_10 = { class: "flex flex-row py-4" }
const _hoisted_11 = { class: "mt-4 w-6/12" }
const _hoisted_12 = { class: "bg-gray-lp-700 px-5 pl-5 pb-2 w-6/12" }
const _hoisted_13 = { class: "pl-5 pb-2 w-6/12" }
const _hoisted_14 = { class: "flex flex-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_UploadFile = _resolveComponent("UploadFile")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Title = _resolveComponent("Title")!
  const _component_Select = _resolveComponent("Select")!
  const _component_button_outline = _resolveComponent("button-outline")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_DataWrapper, {
            label: "Client Code",
            class: "py-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_lp_input, {
                modelValue: _ctx.clientCode,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.clientCode = $event)),
                disabled: true
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, {
            label: "Client Name",
            class: "py-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SelectSearch, {
                onFilter: _ctx.fetchPosClient,
                options: _ctx.posClientList,
                isLoading: _ctx.isLoadingPosClient,
                keyName: "name",
                isShowErrorIndicator: _ctx.form.clientName.isBanned,
                errorCaption: "Partner atau Client Sedang Tidak Aktif",
                keyValue: "id",
                modelValue: _ctx.clientName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.clientName = $event)),
                placeholder: "Cari client",
                class: "mt-2",
                onChange: _ctx.setClientCode
              }, null, 8, ["onFilter", "options", "isLoading", "isShowErrorIndicator", "modelValue", "onChange"])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_DataWrapper, {
            label: "Berkas Lampiran",
            class: "py-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_UploadFile, {
                modelValue: _ctx.archiveFile,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.archiveFile = $event)),
                isClear: _ctx.isClearFile,
                "onUpdate:isClear": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isClearFile = $event)),
                type: "xlsx",
                maxRows: _ctx.maxRow,
                isDraggable: false
              }, null, 8, ["modelValue", "isClear", "maxRows"])
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_button_fill, {
          custom: "px-10 bg-red-lp-200",
          title: "Upload",
          isDisabled: !_ctx.archiveFile,
          onClick: _ctx.extractFile,
          isLoading: _ctx.loadingUpload
        }, null, 8, ["isDisabled", "onClick", "isLoading"])
      ]),
      (_ctx.tempExcel.length > 0)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _hoisted_8,
            _createVNode(_component_Title, {
              label: "Data Client Booking",
              class: "py-6 text-20px"
            }),
            _hoisted_9,
            _createVNode("div", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode("table", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tempExcel, (item, index) => {
                    return (_openBlock(), _createBlock("tr", { key: index }, [
                      _createVNode("td", _hoisted_12, _toDisplayString(item.sheetClient), 1),
                      _createVNode("td", _hoisted_13, [
                        _createVNode(_component_Select, {
                          value: item.sheetGenesis,
                          dataSelect: _ctx.sheetDefaultGenesis,
                          onOpenMenu: ($event: any) => (_ctx.openMenu(index)),
                          onCloseMenu: ($event: any) => (_ctx.closeMenu(index)),
                          onChooseSelect: _ctx.onSelectSheet,
                          class: "w-full",
                          isOpenMenu: item.activitySelect
                        }, null, 8, ["value", "dataSelect", "onOpenMenu", "onCloseMenu", "onChooseSelect", "isOpenMenu"])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode(_component_button_outline, {
                custom: "bg-white px-12 border border-gray-lp-400 text-gray-lp-500 mr-4",
                title: "Cancel",
                onClick: _ctx.cancel
              }, null, 8, ["onClick"]),
              _createVNode(_component_button_fill, {
                custom: "px-10 bg-red-lp-200",
                title: "Simpan",
                onClick: _ctx.submit,
                isDisabled: _ctx.submitDisable
              }, null, 8, ["onClick", "isDisabled"])
            ])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      title: "Pembuatan Config Berhasil",
      onSubmit: _ctx.successSubmit,
      message: `Pembuatan client booking berhasil tersimpan`,
      image: "image-modal-success",
      textSuccess: "OK",
      class: "px-8"
    }, null, 8, ["onSubmit"]), [
      [_vShow, _ctx.isSuccess]
    ])
  ]))
}